import axios from "../axios";

export const OrbitLogin = async (email, password, keepMeLoggedIn = false) => {
  const payload = {
    email,
    password,
    keepMeLoggedIn,
  };
  try {
    const response = await axios.post("api/Auth/Login", payload, {
      headers: {
        "X-Public-Request": true,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get UserName and email after login
//Harshada Bhavsar - (20/11/2025)
export const GetCurrentUser = async () => {
  try {
    const response = await axios.get("api/Auth/me");
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to fetch user");
    } else {
      throw new Error("Network error or server unreachable");
    }
  }
};

export const Logout = async () => {
  return axios.post("/api/Auth/Logout");
};

export const ForceLogout = async (email, slot) => {
  return axios.post("/api/Auth/ForceLogout", { email, slot });
};
